import { render, staticRenderFns } from "./AddAPIEndpointSidePanel.vue?vue&type=template&id=fe3c4be0&"
import script from "./AddAPIEndpointSidePanel.vue?vue&type=script&lang=ts&"
export * from "./AddAPIEndpointSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports